import { callApi } from "../article-feed/utils/callApi";
import { generateSidebar } from "./utils/generateSidebar";

export const ArticleSidebar = async (element) => {
  const url = element.getAttribute("data-path");
  const articles = await callApi(url, element);

  element.querySelector("ul").innerHTML = generateSidebar(articles);
};
